import bindAll from 'lodash.bindall';
import React from 'react';
import { connect } from 'react-redux';
import { getQuery, xesCookie } from "./xes-lib";
import { validateCode, getProjectData, getTemplateData, getMBlockToken, refreshMBlockToken, isTeacherEnd, isCorrectEnd, copyToClipboard } from "./xes.js";
import { XesLoadingState, resetLoadingState, onXESLoadDone } from "../../reducers/project-state";
import { setProjectTitle } from "../../reducers/project-title";
import mblock from "../mblock-sdk";
import storage from '../storage'
import projectData from "../../mock/xes-project-data";
import {
    setXesProjectId,
    setXesProjectMeta
} from '../../reducers/project-state';
import { alertError } from "../../components/modal/alert-modal";

const XesProjectHOC = function (WrappedComponent) {
    class XesProjectComponent extends React.Component {
        constructor(props) {
            super(props);
            bindAll(this, [
                'fetchToken',
                'fetchProject',
                'initScratch',
                'onloadFunc'
            ])

            /**
             * 从xml加载项目
             * xml 
             * name
             * project_id
             */
            window.loadScratchFromXml = (data) => {
                validateCode(data.xml).then(() => {
                    this.initScratch(data)
                }).catch(() => {
                    alert("代码校验失败，请传入合法的xml")
                })
            }

            window.exportScratch = (data) => {
                try {
                    window.parent.window.handleMessage(data)
                } catch (error) {
                    console.info('window.exportScratch', error)
                }
                return new Promise((resolve, reject) => {
                    return resolve();
                });
            }

            window.handleInterfaceError = (type, msg) => {
                if (type === 1) {
                    this.fetchToken()
                } else if (type === 2) {
                    this.refreshToken()
                }
            }
        }

        componentDidMount() {
            window.addEventListener('load', this.onloadFunc.bind(this));
        }
        componentDidUpdate() {
            if (this.props.xesLoadingState === XesLoadingState.XES_RESET) {
                return
            }
            if (this.props.xesLoadingState === XesLoadingState.XES_INITING) {
                getTemplateData().then(data => {
                    this.initScratch(data)
                })
            }
            this.props.resetLoadingState()
        }
        onloadFunc() {
            console.log(mblock)
            // TODO: undefined请求的问题
            storage.addXesWebStore(mblock)
            console.log(window.location.search)
            mblock.init()
            this.fetchToken()
            this.fetchProject()
        }

        fetchToken() {
            if (xesCookie.getCookie('accesstoken')) {
                return
            }
            getMBlockToken().then((data) => {
                if (Number(data.code) === 0) {
                    xesCookie.setCookie('accesstoken', data.data.accesstoken, 1)
                }
            }).catch(err => {
                if (isTeacherEnd()) {
                    if (window.location.href.indexOf('stuId') > -1) {
                        const cleanHref = window.location.href.replace(/&amp;/g, '&');
                        alertError("未登陆，请复制链接到浏览器打开：" + cleanHref, "复制链接", () => {
                            copyToClipboard(cleanHref)
                                .then(() => {
                                    console.log('链接已复制到剪贴板');
                                })
                                .catch((err) => {
                                    console.error('复制失败:', err);
                                    // 如果复制失败，可以提示用户手动复制
                                    alert('复制失败，请手动复制链接：' + cleanHref);
                                });
                        })
                    }
                } else {
                    alert("请登陆后刷新重试")
                }
            })
        }

        refreshToken() {
            refreshMBlockToken().then((data) => {
                console.log(data)
            })
        }

        fetchProject() {
            getProjectData().then((data) => {
                validateCode(data.xml).then(() => {
                    this.initScratch(data)
                }).catch(() => {
                    let from = getQuery('from', 'id')
                    if(from != 'xml'){
                        alert("代码获取失败，请刷新页面重试")
                    }
                    let loading = document.getElementById(
                        "loading-wrapper"
                    );
                    if (loading) document.body.removeChild(loading);
                })
            }).catch(() => {
                let from = getQuery('from', 'id')
                if(from != 'xml'){
                    alert("代码获取失败，请刷新页面重试")
                }
                let loading = document.getElementById(
                    "loading-wrapper"
                );
                if (loading) document.body.removeChild(loading);
            })
        }
        initScratch(data) {
            let {
                xml,
                ...projectMeta
            } = data
            this.props.setProjectTitle(data.name)
            this.props.setXesProjectMeta(projectMeta)
            this.props.onXesProjectLoaded()
            mblock.loadProjectByJson(xml)
        }
        render() {
            const {
                setXesProjectId,
                setXesProjectMeta,
                ...componentProps
            } = this.props;
            return (
                <WrappedComponent
                    {...componentProps}
                />
            );
        }
    }
    XesProjectComponent.propTypes = {
    };
    const mapStateToProps = state => {
        return ({
            xesLoadingState: state.scratchGui.xesProjectState.xesLoadingState
        });
    }
    const mapDispatchToProps = dispatch => ({
        setXesProjectId: xesProjectId => {
            dispatch(setXesProjectId(xesProjectId));
        },
        setXesProjectMeta: projectMeta => {
            dispatch(setXesProjectMeta(projectMeta))
        },
        setProjectTitle: title => {
            dispatch(setProjectTitle(title))
        },
        resetLoadingState: () => dispatch(resetLoadingState()),
        onXesProjectLoaded: () => dispatch(onXESLoadDone())
    });

    return connect(
        mapStateToProps,
        mapDispatchToProps
    )(XesProjectComponent);
};

export {
    XesProjectHOC as default
};
